import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.link.js";
import { defineComponent as _defineComponent } from 'vue';
import AzBreadcrumbs from '~/components/_next/atoms/AzBreadcrumbs.vue';
import { SCHEMA } from '~/constants';
export default /*#__PURE__*/_defineComponent({
  __name: 'BaseSingleBreadcrumb',
  props: {
    breadcrumbs: null
  },
  setup: function setup(__props) {
    var props = __props;
    var productCategory = computed(function () {
      var breadcrumbs = props.breadcrumbs;
      return breadcrumbs.length === 1 ? breadcrumbs[0] : breadcrumbs[breadcrumbs.length - 2];
    });
    useHead(function () {
      var breadcrumb = {
        '@context': SCHEMA,
        '@type': 'BreadcrumbList',
        'itemListElement': props.breadcrumbs.map(function (breadcrumb, i) {
          return {
            '@type': 'ListItem',
            'position': i + 1,
            'item': {
              '@id': "".concat(process.env.DOMAIN).concat(breadcrumb.link),
              'name': breadcrumb.text
            }
          };
        })
      };
      return {
        script: [{
          type: 'application/ld+json',
          innerHTML: JSON.stringify(breadcrumb)
        }]
      };
    });
    return {
      __sfc: true,
      props: props,
      productCategory: productCategory,
      AzBreadcrumbs: AzBreadcrumbs
    };
  }
});